import React, { Component } from "react";
import ChooseButton from "./../shared/ChooseButton";
import Contentify from "../../content/Contentify";
import Store from "./../../content/Store";
import LabelWithTooltip from "./../shared/label/LabelWithTooltip";
import StatusPanel from "../shared/notices/StatusPanel";
import { updateMakeAClaimProperties } from "../../actions/makeAClaim/MakeAClaimActions";
import {
  MEDICAL_TREATMENT,
  IN_PATIENT_NHS,
  DENTAL_OR_OPTICAL,
  PRIVATE_GP_FEES,
  CHIROPODY_PODIATRY,
  CHILD_BIRTH,
  NHS_CHEMO_RADIO,
  CLAIM_BACK_OPTIONS_CONTENT
} from "./Constants";
import { connect } from "react-redux";
import styles from "./../../assets/css/modules/makeAClaim/claim-back-options.css";
import CheckListForClaimBack from "./CheckListForClaimBack";
import ChemotherapyOrRadiotherapyTreatment from "./ChemotherapyOrRadiotherapyTreatment";
import GetStartedButton from "./GetStartedButton";
import MedicalTreatment from "./MedicalTreatment";
import Scroll from "react-scroll";
import { Layouts } from "../../constants/Constants";
import {
  PrivateGP,
  DentOptCash,
  DentOptCashPlus
} from "../../constants/SMEModules";
import { shouldShowIfAllSMEModulesDontMatch } from "../../helpers/SMEModules/smeModuleHelper";

export class ClaimBackOptions extends Component {
  static content = {
    ...Store.ClaimBackOptions,
    InPatient: Store.InPatient,
    DentalOrOptical: Store.DentalOrOptical,
    PrivateGPFees: Store.PrivateGPFees,
    ChiropodyPodiatry: Store.ChiropodyPodiatry,
    ChildBirth: Store.ChildBirth,
    SMEDentalOrOptical: Store.SMEDentalOrOptical,
    SMEPrivateGPFees: Store.SMEPrivateGPFees
  };

  getContentForClaimBackOption = () => {
    const {
      content,
      claimBackOption,
      hasDefaultOptions,
      hasDentOptCash,
      hasPrivateGP
    } = this.props;
    if (claimBackOption === DENTAL_OR_OPTICAL) {
      return !hasDefaultOptions && hasDentOptCash
        ? content.SMEDentalOrOptical
        : content.DentalOrOptical;
    } else if (claimBackOption === PRIVATE_GP_FEES) {
      return !hasDefaultOptions && hasPrivateGP
        ? content.SMEPrivateGPFees
        : content.PrivateGPFees;
    } else if (claimBackOption === CHIROPODY_PODIATRY) {
      return content.ChiropodyPodiatry;
    } else if (claimBackOption === CHILD_BIRTH) {
      return content.ChildBirth;
    }
    return content.InPatient;
  };

  getPropertiesToUpdateForClaimBackOption = (selectedClaimBackOption) => {
    let propertiesToUpdate = {
      isNewClaim: null,
      nhsChemoRadioTreatmentType: null,
      claimBackOption: selectedClaimBackOption,
      preAuth: null,
      action: null
    };
    if (selectedClaimBackOption === DENTAL_OR_OPTICAL) {
      propertiesToUpdate.action = "cashBenefitDental";
    } else if (selectedClaimBackOption === PRIVATE_GP_FEES) {
      propertiesToUpdate.action = "cashBenefitPrivateGP";
    } else if (selectedClaimBackOption === CHIROPODY_PODIATRY) {
      propertiesToUpdate.action = "cashBenefitChiropody";
    } else if (selectedClaimBackOption === CHILD_BIRTH) {
      propertiesToUpdate.action = "cashBenefitChildbirth";
    } else if (selectedClaimBackOption === NHS_CHEMO_RADIO) {
      propertiesToUpdate.action = "cashBenefitNHSChemo";
    } else if (selectedClaimBackOption === IN_PATIENT_NHS) {
      propertiesToUpdate.action = "cashBenefitInPatient";
    }
    return propertiesToUpdate;
  };

  generateChooseButton = (contentForButton, selectedClaimBackOption, id) => (
    <div className={styles.chooseButtonWrapper} id={id}>
      <ChooseButton
        selected={this.props.claimBackOption === selectedClaimBackOption}
        horizontal
        {...contentForButton}
        onClick={() => {
          this.props.updateMakeAClaimProperties(
            this.getPropertiesToUpdateForClaimBackOption(
              selectedClaimBackOption
            )
          );
          Scroll.scroller.scrollTo(CLAIM_BACK_OPTIONS_CONTENT, {
            duration: 750,
            smooth: true
          });
        }}
      >
        {selectedClaimBackOption !== MEDICAL_TREATMENT && (
          <div className={styles.statusPanel}>
            <StatusPanel
              text={this.props.content.cashBenefitStatusLabel}
              statusColour="blue"
            />
          </div>
        )}
      </ChooseButton>
    </div>
  );

  renderClaimBackOptionsContent = () => {
    const { claimBackOption } = this.props;
    if (claimBackOption) {
      if (claimBackOption === NHS_CHEMO_RADIO) {
        return <ChemotherapyOrRadiotherapyTreatment />;
      } else if (claimBackOption === MEDICAL_TREATMENT) {
        return <MedicalTreatment />;
      } else {
        return (
          <div className={styles.checkListForClaimBack}>
            <CheckListForClaimBack
              content={this.getContentForClaimBackOption()}
            />
            <GetStartedButton />
          </div>
        );
      }
    }
    return;
  };

  render() {
    const {
      content,
      hasDefaultOptions,
      hasPrivateGP,
      hasDentOptCash
    } = this.props;
    return (
      <div>
        {(hasDefaultOptions || (hasPrivateGP && hasDentOptCash)) && (
          <LabelWithTooltip
            label={content.label}
            tooltipContent={content.tooltip}
          />
        )}
        {hasDefaultOptions &&
          this.generateChooseButton(
            content.buttons.medicalTreatment,
            MEDICAL_TREATMENT,
            "medicalTreatment"
          )}
        {hasDefaultOptions &&
          this.generateChooseButton(
            content.buttons.inPatientNHS,
            IN_PATIENT_NHS,
            "inPatientNHS"
          )}
        {hasDentOptCash &&
          this.generateChooseButton(
            content.buttons.dentalOrOptical,
            DENTAL_OR_OPTICAL,
            "dentalOrOptical"
          )}
        {hasPrivateGP &&
          !this.props.isSaga &&
          this.generateChooseButton(
            content.buttons.privateGPFees,
            PRIVATE_GP_FEES,
            "privateGpFees"
          )}
        {hasDefaultOptions &&
          (this.props.isHealthSelect || this.props.layout === Layouts.HOL) &&
          this.generateChooseButton(
            content.buttons.chiropodyPodiatry,
            CHIROPODY_PODIATRY,
            "chiropodyPodiatry"
          )}
        {hasDefaultOptions &&
          !this.props.isSaga &&
          this.props.layout !== Layouts.HOL &&
          this.generateChooseButton(
            content.buttons.childbirth,
            CHILD_BIRTH,
            "childbirth"
          )}
        {hasDefaultOptions &&
          this.generateChooseButton(
            content.buttons.nhsChemoOrRadio,
            NHS_CHEMO_RADIO,
            "nhsChemoOrRadio"
          )}
        <div name={CLAIM_BACK_OPTIONS_CONTENT}>
          {this.renderClaimBackOptionsContent()}
        </div>
      </div>
    );
  }
}

export const mapStateToClaimBackOptions = ({
  layoutReducer,
  makeAClaimReducer,
  policyReducer
}) => {
  let hasPrivateGP = policyReducer.selectedPolicy.SMEModules.includes(
    PrivateGP
  );
  let hasDentOptCash =
    policyReducer.selectedPolicy.SMEModules.includes(DentOptCash) ||
    policyReducer.selectedPolicy.SMEModules.includes(DentOptCashPlus);
  let hasDefaultOptions = shouldShowIfAllSMEModulesDontMatch(
    policyReducer.selectedPolicy,
    [PrivateGP, DentOptCash, DentOptCashPlus]
  );
  let claimBackOption = makeAClaimReducer.claimBackOption;
  if (hasPrivateGP && !hasDefaultOptions && !hasDentOptCash) {
    claimBackOption = PRIVATE_GP_FEES;
  } else if (hasDentOptCash && !hasDefaultOptions && !hasPrivateGP) {
    claimBackOption = DENTAL_OR_OPTICAL;
  }
  return {
    claimBackOption,
    isSaga: policyReducer.selectedPolicy.IsSaga,
    isHealthSelect: policyReducer.selectedPolicy.IsHealthSelect,
    layout: layoutReducer.layout,
    hasPrivateGP: !policyReducer.selectedPolicy.IsSMEModular || hasPrivateGP,
    hasDentOptCash:
      !policyReducer.selectedPolicy.IsSMEModular || hasDentOptCash,
    hasDefaultOptions
  };
};

export default connect(mapStateToClaimBackOptions, {
  updateMakeAClaimProperties
})(Contentify(ClaimBackOptions));
